//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from 'lodash'

export default {
  data() {
    return {
      empty: {
        email: ''
      },
      form: {},
      pageReady: false,
      processing: false
    }
  },

  created() {
    this.setForm()
    this.form.email = this.$route.query.email || ''
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      setTimeout(() => {
        this.pageReady = true
      }, 1000)
    },

    setForm() {
      this.form = cloneDeep(this.empty)
    },

    async send() {
      try {
        // Set processing
        this.processing = true

        // Login
        await this.$api.auth.recoveryPassword(this.form)

        // Reset form
        this.setForm()

        // Set processing
        this.processing = false

        // Show success
        this.$store.dispatch('modal/show', {
          type: 'success',
          title: 'E-mail enviado!',
          message: `Você receberá um link no e-mail para criar uma nova senha.`,
          actionUrl: '/area-restrita'
        })
      } catch (err) {
        // Log the error
        console.log(err)

        // Set processing
        this.processing = false

        // Show error
        this.$store.dispatch('modal/show', {
          type: 'danger',
          title: 'Erro na autenticação',
          message:
            'Houve algum erro ao tentar entrar recuperar a senha, por favor verifique se o e-mail foi preenchido corretamente.'
        })
      }
    }
  }
}
